export * from './editable-table/editable-table.service';
export * from './editable-table/editable-table.component';
export * from './editable-table/editable-table.module';
export * from './util/table-cell';
export * from './util/table-row';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
